export enum NotificationChannel {
	None,
	PrivateMessage,
	Email2
}